import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { useAuth } from '../context/AuthContext';

export const SEEN_KEY = 'bs_msg_seen';

export function useUnread() {
  const { user } = useAuth();
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!user || user.isAdmin) return undefined;
    let stop = false;
    const load = () => {
      let since = null;
      try { since = localStorage.getItem(SEEN_KEY); } catch (e) {}
      api.messagesUnread(since).then(r => { if (!stop) setN(r.count || 0); }).catch(() => {});
    };
    load();
    const t = setInterval(load, 60000);
    return () => { stop = true; clearInterval(t); };
  }, [user]);
  return n;
}

export function MessageBell() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const n = useUnread();
  if (!user || user.isAdmin) return null;
  return (
    <button onClick={() => navigate('/messages')} aria-label={n ? `${n} nouveau(x) message(s)` : 'Messages'}
      style={{ position: 'relative', width: 44, height: 44, borderRadius: 22, border: '1.5px solid #E3DCCF', background: '#F6F2EC', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, padding: 0 }}>
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#173B34" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 5h16v11H9l-5 4z" /></svg>
      {n > 0 && <span style={{ position: 'absolute', top: -2, right: -2, background: '#E4572E', color: '#fff', borderRadius: 10, minWidth: 18, height: 18, fontSize: 11, fontWeight: 700, lineHeight: '18px', textAlign: 'center', padding: '0 4px' }}>{n}</span>}
    </button>
  );
}
